import { render } from "./OnlineAgreementPage.vue?vue&type=template&id=322f93d5&scoped=true&ts=true"
import script from "./OnlineAgreementPage.vue?vue&type=script&lang=ts"
export * from "./OnlineAgreementPage.vue?vue&type=script&lang=ts"

import "./OnlineAgreementPage.vue?vue&type=style&index=0&id=322f93d5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322f93d5"]])

export default __exports__